import { InitScanPayload,  ScanProgressResponse } from '../types/interfaces';
import apiClient from './config';

export const getTotalScanCount = async (): Promise<number> => {
  try {
    const response = await apiClient.get('/scan/stats/count');
    return response.data.count;
  } catch (error) {
    return 0;
  }
};


export const startScanV2 = async (
  domain: string
): Promise<InitScanPayload> => {
  try {
    const response = await apiClient.get<InitScanPayload>(
      `/scan/v2/${encodeURIComponent(domain)}`
    );
    return response.data;
  } catch (error: any) {
    console.error('startScanV2 error:', error);
    throw error;
  }
};

export const fetchScanProgress = async (
  scanId: string
): Promise<ScanProgressResponse> => {
  const { data } = await apiClient.get<ScanProgressResponse>(`/scan/${scanId}/progress`);
  return data;
};